/**
 * header.js
 * Handles: cookie utils, cart init, language URL rewriter,
 * login/register modals, Langify market selector integration.
 */
(function() {
  'use strict';

  /* ================================================================
   * 1. COOKIE UTILITIES
   * ================================================================ */
  function createCookie(name, value, days) {
    var expires = '';
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = '; expires=' + date.toGMTString();
    }
    document.cookie = name + '=' + value + expires + '; path=/';
  }

  function readCookie(name) {
    var nameEQ = name + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length);
    }
    return null;
  }

  // Expose for cart-drawer.js compatibility
  window.createCookie2 = createCookie;
  window.readCookie2 = readCookie;

  /* ================================================================
   * 2. DOM CONTENT LOADED
   * ================================================================ */
  document.addEventListener('DOMContentLoaded', function() {
    var language = window.location.pathname.split('/')[1];

    // Initialize cart session if no cart cookie exists
    if (readCookie('cart') === null) {
      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(data) {
          if (!data.item_count) {
            fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ updates: {} })
            }).catch(function() { /* cart update failed silently */ });
          }
        })
        .catch(function() { /* cart init failed silently */ });
    }

    // Language URL rewriter — only for non-English locales
    var supportedLangs = ['fr-fr', 'de-de', 'es-es', 'it-it', 'nl-nl'];
    if (!language || supportedLangs.indexOf(language) === -1) return;

    var currentDomain = window.location.hostname;
    var allLinks = document.querySelectorAll('a:not(.btn-language)');

    allLinks.forEach(function(link) {
      var href = link.getAttribute('href');
      if (!href) return;

      if (href.startsWith('/')) {
        if (href.indexOf('/' + language + '/') === -1) {
          link.setAttribute('href', '/' + language + href);
        }
      } else if (href.indexOf(currentDomain) !== -1 && href.startsWith('http')) {
        if (href.indexOf('/' + language + '/') === -1) {
          link.setAttribute('href', href.replace(currentDomain, currentDomain + '/' + language));
        }
      }
    });
  });

  /* ================================================================
   * 3. LOGIN/REGISTER MODALS
   * ================================================================ */
  document.addEventListener('DOMContentLoaded', function() {
    var modallogin = document.getElementById('loginPopup');
    var btnlogin = document.getElementById('loginBtnPopup');
    var spanlogin = document.getElementsByClassName('loginClose')[0];
    var modalreg = document.getElementById('registerPopup');
    var btnreg = document.getElementById('registerBtnPopup');
    var spanreg = document.getElementsByClassName('registerClose')[0];

    if (btnlogin && modallogin) {
      btnlogin.onclick = function() {
        modallogin.style.display = 'block';
        document.body.style.overflowY = 'hidden';
      };
    }
    if (spanlogin && modallogin) {
      spanlogin.onclick = function() {
        modallogin.style.display = 'none';
        document.body.style.overflowY = '';
      };
    }
    if (btnreg && modalreg) {
      btnreg.onclick = function() {
        modalreg.style.display = 'block';
        document.body.style.overflowY = 'hidden';
      };
    }
    if (spanreg && modalreg) {
      spanreg.onclick = function() {
        modalreg.style.display = 'none';
        document.body.style.overflowY = '';
      };
    }

    window.addEventListener('click', function(event) {
      if (modallogin && event.target === modallogin) {
        modallogin.style.display = 'none';
        document.body.style.overflowY = '';
      }
      if (modalreg && event.target === modalreg) {
        modalreg.style.display = 'none';
        document.body.style.overflowY = '';
      }
    });
  });

})();
